import { motion } from "framer-motion";
import CountUp from "react-countup";

const TotalCard = ({ text, icons, color = "#1976d2", repeat = Infinity, width }) => {
  const parsedText = String(text || "");
  const match = parsedText.match(/^(.*?)(-?\d+(?:\.\d+)?)\s*$/);
  const labelPart = match ? match[1] : parsedText;
  const valuePart = match ? Number(match[2]) : null;

  return (
    <motion.div
      initial={{ opacity: 0, x: -30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="w-full sm:w-auto"
      style={{ width }}
    >
      <motion.div
        whileHover={{ y: -3 }}
        className="flex items-center gap-4 shadow-md hover:shadow-lg transition rounded-2xl p-4 border border-transparent backdrop-blur-md"
        style={{
          background:
            "linear-gradient(160deg, #ffffff 0%, #f5faff 100%) padding-box, linear-gradient(125deg, rgba(130, 168, 216, 0.45) 0%, rgba(122, 163, 214, 0.45) 50%, rgba(140, 180, 226, 0.45) 100%) border-box",
          boxShadow: "0 10px 24px rgba(23, 61, 111, 0.12)",
        }}
      >
        <div
          className="flex items-center justify-center "
          
        >
          <span
            className="text-white text-xl p-2 rounded-2xl text-center border border-white/35"
            style={{ backgroundImage: `linear-gradient(120deg, ${color} 0%, #2563eb 100%)` }}
          >
            {icons}
          </span>
        </div>

        <motion.div
          animate={{ opacity: [1, 0.4, 1] }}
          transition={{ duration: 1.5, repeat, ease: "easeInOut" }}
          className="text-[#153f71] font-semibold text-base sm:text-lg"
        >
          {valuePart === null ? (
            parsedText
          ) : (
            <>
              {labelPart}
              <CountUp end={valuePart} duration={1.2} separator="," />
            </>
          )}
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default TotalCard;
